import { render, staticRenderFns } from "./evidense.vue?vue&type=template&id=1aff3c35"
import script from "./evidense.vue?vue&type=script&lang=js"
export * from "./evidense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports